module.exports = require("plugin-liverig/shared/curves/handson-table");